import { openBlock as f, createElementBlock as y, createElementVNode as C, defineComponent as $, ref as D, onMounted as we, nextTick as Ee, normalizeClass as ie, createVNode as H, createCommentVNode as R, Fragment as Q, renderList as se, unref as S, onBeforeUnmount as Oe, createBlock as U, useCssVars as pe, computed as B, withModifiers as ir, reactive as ke, watch as me, mergeProps as j, Teleport as sr, Transition as nr, withCtx as or, toDisplayString as Y, inject as xe, normalizeStyle as ar, mergeModels as lr, useModel as ur, provide as fe } from "//omikujistore.com/cdn/shop/t/13/assets/lib.vue.js?v=39460745490713962181762147867";
import { _ as L, u as Ie } from "//omikujistore.com/cdn/shop/t/13/assets/v-useLocale-CrhIBLM-.js?v=104820010258233384051762147945";
import { C as cr, u as dr, a as pr } from "//omikujistore.com/cdn/shop/t/13/assets/v-useShopifyCart-BbcUYiKA.js?v=47545376325038546501762148615";
import { u as Ce } from "//omikujistore.com/cdn/shop/t/13/assets/v-useBlockUtils-BaCwKmb9.js?v=107575913281100606751762147945";
import { u as mr, a as vr, O as fr } from "//omikujistore.com/cdn/shop/t/13/assets/v-useOmikujiEventBus-NUygTxYd.js?v=77258134192849111251762147945";
import { _ as gr } from "//omikujistore.com/cdn/shop/t/13/assets/v-ErrorLine.vue_vue_type_style_index_0_lang-BQIeWCNR.js?v=24907443763274068641762148615";
const Pe = "product_pictures", Me = "pictures_additional_infos", wr = [Pe, Me], br = [
  "brand_n_collection",
  "product_name",
  "product_price",
  "separator",
  "variant_selector",
  "add_to_cart_button",
  "description",
  "r_column_additional_infos",
  "omikujis_waranties"
], yr = {}, hr = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "11",
  viewBox: "0 0 18 11",
  fill: "none"
};
function _r(o, s) {
  return f(), y("svg", hr, s[0] || (s[0] = [
    C("path", {
      d: "M17 1.48267L9 10.1235L1 1.48267",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const Se = /* @__PURE__ */ L(yr, [["render", _r]]);
function Ae() {
  let o = !1;
  function s(u) {
    return (m, c) => {
      o = !0, u && u(m, c);
    };
  }
  function p(u) {
    return (m, c) => {
      o = !1, u && u(m, c);
    };
  }
  function l(u) {
    return (m, c) => {
      u && o && u(m, c);
    };
  }
  return { promise: s, reject: p, accept: l };
}
const Tr = ["onPointerup"], Sr = ["src"], Er = /* @__PURE__ */ $({
  __name: "ImagesCarousel",
  props: {
    imgsUrls: {
      type: Array,
      required: !0
    },
    vertical: {
      type: Boolean,
      required: !1,
      default: !0
    }
  },
  emits: ["selectPicture"],
  setup(o, { emit: s }) {
    const p = o, { promise: l, reject: u, accept: m } = Ae(), c = l(), n = u(), v = D(
      0
      /* HIDE_BOTH */
    ), d = D(null), h = s;
    function T() {
      if (!d.value) return;
      let k, i, a;
      p.vertical ? (k = d.value.scrollTop, i = d.value.clientHeight, a = d.value.scrollHeight) : (k = d.value.scrollLeft, i = d.value.clientWidth, a = d.value.scrollWidth), a == i ? v.value = 0 : k == 0 ? v.value = 3 : k + i >= a - 1 ? v.value = 1 : v.value = 2;
    }
    function O(k) {
      d.value && (p.vertical ? d.value.scrollTop += k * 100 : d.value.scrollLeft += k * 200);
    }
    const N = m((k, i) => {
      if (i !== void 0 && h("selectPicture", i), !d.value) return;
      const a = k.target;
      p.vertical ? d.value.scrollTop = a.offsetTop : d.value.scrollLeft = a.offsetLeft;
    });
    return we(() => {
      Ee(() => {
        T();
      });
    }), (k, i) => (f(), y("div", {
      class: ie(["product-images-carousel", { vertical: o.vertical }])
    }, [
      [
        2,
        1
        /* SHOW_TOP */
      ].includes(v.value) ? (f(), y("div", {
        key: 0,
        class: "arrow-overlay",
        onPointerdownCapture: i[0] || (i[0] = (a) => O(-1))
      }, [
        H(Se, {
          class: "arrow",
          width: "18",
          height: "11"
        })
      ], 32)) : R("", !0),
      C("div", {
        ref_key: "scroller",
        ref: d,
        onScroll: T,
        class: "scroller"
      }, [
        (f(!0), y(Q, null, se(o.imgsUrls, (a, t) => (f(), y("div", {
          key: a,
          class: "image-container",
          onPointerdown: i[1] || (i[1] = //@ts-ignore
          (...e) => S(c) && S(c)(...e)),
          onTouchmove: i[2] || (i[2] = //@ts-ignore
          (...e) => S(n) && S(n)(...e)),
          onPointerup: (e) => S(N)(e, t)
        }, [
          C("img", {
            src: a,
            class: "product-image"
          }, null, 8, Sr)
        ], 40, Tr))), 128))
      ], 544),
      [
        2,
        3
        /* SHOW_BOTTOM */
      ].includes(v.value) ? (f(), y("div", {
        key: 1,
        class: "arrow-overlay reverse",
        onPointerdown: i[3] || (i[3] = (a) => O(1))
      }, [
        H(Se, {
          class: "arrow",
          width: "18",
          height: "11"
        })
      ], 32)) : R("", !0)
    ], 2));
  }
}), ge = /* @__PURE__ */ L(Er, [["__scopeId", "data-v-6410392f"]]), Or = { class: "fullscreen-image-viewer" }, kr = { class: "large-image-container" }, xr = ["src"], Ir = /* @__PURE__ */ $({
  __name: "FullScreenProductImage",
  props: {
    imgsUrls: {
      type: Array,
      required: !0
    },
    openedImage: {
      type: String,
      required: !0
    },
    displayCarousel: {
      type: Boolean,
      required: !0
    }
  },
  emits: ["close"],
  setup(o, { emit: s }) {
    const p = o, l = s, { lockElement: u, unlockElement: m } = dr(
      document.body
    ), c = D(
      p.imgsUrls.find((v) => v === p.openedImage)
    );
    function n(v) {
      c.value = p.imgsUrls[v];
    }
    return we(() => {
      u();
    }), Oe(() => {
      m();
    }), (v, d) => (f(), y("div", Or, [
      C("div", {
        class: "closing-cross-container",
        onPointerdown: d[0] || (d[0] = (h) => l("close"))
      }, [
        H(cr, { class: "closing-cross" })
      ], 32),
      C("div", kr, [
        C("img", {
          src: c.value,
          class: "large-image"
        }, null, 8, xr)
      ]),
      o.displayCarousel ? (f(), U(ge, {
        key: 0,
        vertical: !1,
        class: "horizontal-carousel",
        imgsUrls: o.imgsUrls,
        onSelectPicture: d[1] || (d[1] = (h) => n(h))
      }, null, 8, ["imgsUrls"])) : R("", !0)
    ]));
  }
}), Cr = /* @__PURE__ */ L(Ir, [["__scopeId", "data-v-b63f2ec5"]]);
var Ve = { exports: {} };
(function(o) {
  o.exports = /******/
  function(s) {
    var p = {};
    function l(u) {
      if (p[u])
        return p[u].exports;
      var m = p[u] = {
        /******/
        i: u,
        /******/
        l: !1,
        /******/
        exports: {}
        /******/
      };
      return s[u].call(m.exports, m, m.exports, l), m.l = !0, m.exports;
    }
    return l.m = s, l.c = p, l.d = function(u, m, c) {
      l.o(u, m) || Object.defineProperty(u, m, {
        /******/
        configurable: !1,
        /******/
        enumerable: !0,
        /******/
        get: c
        /******/
      });
    }, l.n = function(u) {
      var m = u && u.__esModule ? (
        /******/
        function() {
          return u.default;
        }
      ) : (
        /******/
        function() {
          return u;
        }
      );
      return l.d(m, "a", m), m;
    }, l.o = function(u, m) {
      return Object.prototype.hasOwnProperty.call(u, m);
    }, l.p = "", l(l.s = 1);
  }([
    /* 0 */
    /***/
    function(s, p, l) {
      var u = {
        MOBILE: "mobile",
        TABLET: "tablet",
        SMART_TV: "smarttv",
        CONSOLE: "console",
        WEARABLE: "wearable",
        BROWSER: void 0
      }, m = {
        CHROME: "Chrome",
        FIREFOX: "Firefox",
        OPERA: "Opera",
        YANDEX: "Yandex",
        SAFARI: "Safari",
        INTERNET_EXPLORER: "Internet Explorer",
        EDGE: "Edge",
        CHROMIUM: "Chromium",
        IE: "IE",
        MOBILE_SAFARI: "Mobile Safari",
        EDGE_CHROMIUM: "Edge Chromium"
      }, c = {
        IOS: "iOS",
        ANDROID: "Android",
        WINDOWS_PHONE: "Windows Phone",
        WINDOWS: "Windows",
        MAC_OS: "Mac OS"
      }, n = {
        isMobile: !1,
        isTablet: !1,
        isBrowser: !1,
        isSmartTV: !1,
        isConsole: !1,
        isWearable: !1
      };
      s.exports = { BROWSER_TYPES: m, DEVICE_TYPES: u, OS_TYPES: c, defaultData: n };
    },
    /* 1 */
    /***/
    function(s, p, l) {
      var u = l(2), m = l(0), c = m.BROWSER_TYPES, n = m.OS_TYPES, v = m.DEVICE_TYPES, d = l(4), h = d.checkType, T = d.broPayload, O = d.mobilePayload, N = d.wearPayload, k = d.consolePayload, i = d.stvPayload, a = d.getNavigatorInstance, t = d.isIOS13Check, e = new u(), r = e.getBrowser(), g = e.getDevice(), x = e.getEngine(), w = e.getOS(), b = e.getUA(), X = c.CHROME, ne = c.CHROMIUM, ve = c.IE, z = c.INTERNET_EXPLORER, W = c.OPERA, Z = c.FIREFOX, le = c.SAFARI, q = c.EDGE, J = c.YANDEX, ee = c.MOBILE_SAFARI, I = v.MOBILE, P = v.TABLET, E = v.SMART_TV, A = v.BROWSER, V = v.WEARABLE, re = v.CONSOLE, M = n.ANDROID, te = n.WINDOWS_PHONE, F = n.IOS, ue = n.WINDOWS, ce = n.MAC_OS, Re = function() {
        return g.type === I;
      }, De = function() {
        return g.type === P;
      }, $e = function() {
        switch (g.type) {
          case I:
          case P:
            return !0;
          default:
            return !1;
        }
      }, be = function() {
        return w.name === n.WINDOWS && w.version === "10" ? typeof b == "string" && b.indexOf("Edg/") !== -1 : !1;
      }, Le = function() {
        return g.type === E;
      }, Ue = function() {
        return g.type === A;
      }, qe = function() {
        return g.type === V;
      }, We = function() {
        return g.type === re;
      }, ze = function() {
        return w.name === M;
      }, Fe = function() {
        return w.name === ue;
      }, je = function() {
        return w.name === ce;
      }, He = function() {
        return w.name === te;
      }, Ye = function() {
        return w.name === F;
      }, Ge = function() {
        return r.name === X;
      }, Xe = function() {
        return r.name === Z;
      }, Ze = function() {
        return r.name === ne;
      }, ye = function() {
        return r.name === q;
      }, Ke = function() {
        return r.name === J;
      }, Qe = function() {
        return r.name === le || r.name === ee;
      }, Je = function() {
        return r.name === ee;
      }, et = function() {
        return r.name === W;
      }, tt = function() {
        return r.name === z || r.name === ve;
      }, rt = function() {
        var G = a(), de = G && G.userAgent.toLowerCase();
        return typeof de == "string" ? /electron/.test(de) : !1;
      }, it = function() {
        var G = a();
        return G && (/iPad|iPhone|iPod/.test(G.platform) || G.platform === "MacIntel" && G.maxTouchPoints > 1) && !window.MSStream;
      }, oe = function() {
        return t("iPad");
      }, st = function() {
        return t("iPhone");
      }, nt = function() {
        return t("iPod");
      }, ot = function() {
        return r.major;
      }, at = function() {
        return r.version;
      }, lt = function() {
        return w.version ? w.version : "none";
      }, ut = function() {
        return w.name ? w.name : "none";
      }, ct = function() {
        return r.name;
      }, dt = function() {
        return g.vendor ? g.vendor : "none";
      }, pt = function() {
        return g.model ? g.model : "none";
      }, mt = function() {
        return x.name;
      }, vt = function() {
        return x.version;
      }, ft = function() {
        return b;
      }, gt = function() {
        return g.type;
      }, wt = Le(), bt = We(), yt = qe(), ht = Je() || oe(), _t = Ze(), Tt = $e() || oe(), St = Re(), Et = De() || oe(), Ot = Ue(), kt = ze(), xt = He(), It = Ye() || oe(), Ct = Ge(), Pt = Xe(), Mt = Qe(), At = et(), Vt = tt(), Nt = lt(), Bt = ut(), Rt = ot(), Dt = at(), $t = ct(), Lt = dt(), Ut = pt(), qt = mt(), Wt = vt(), zt = ft(), Ft = ye() || be(), jt = Ke(), Ht = gt(), Yt = it(), Gt = oe(), Xt = st(), Zt = nt(), Kt = rt(), Qt = be(), Jt = ye(), er = Fe(), tr = je(), K = h(g.type);
      function rr() {
        var _ = K.isBrowser, G = K.isMobile, de = K.isTablet, he = K.isSmartTV, _e = K.isConsole, Te = K.isWearable;
        if (_)
          return T(_, r, x, w, b);
        if (he)
          return i(he, x, w, b);
        if (_e)
          return k(_e, x, w, b);
        if (G || de)
          return O(K, g, w, b);
        if (Te)
          return N(Te, x, w, b);
      }
      s.exports = {
        deviceDetect: rr,
        isSmartTV: wt,
        isConsole: bt,
        isWearable: yt,
        isMobileSafari: ht,
        isChromium: _t,
        isMobile: Tt,
        isMobileOnly: St,
        isTablet: Et,
        isBrowser: Ot,
        isAndroid: kt,
        isWinPhone: xt,
        isIOS: It,
        isChrome: Ct,
        isFirefox: Pt,
        isSafari: Mt,
        isOpera: At,
        isIE: Vt,
        osVersion: Nt,
        osName: Bt,
        fullBrowserVersion: Rt,
        browserVersion: Dt,
        browserName: $t,
        mobileVendor: Lt,
        mobileModel: Ut,
        engineName: qt,
        engineVersion: Wt,
        getUA: zt,
        isEdge: Ft,
        isYandex: jt,
        deviceType: Ht,
        isIOS13: Yt,
        isIPad13: Gt,
        isIPhone13: Xt,
        isIPod13: Zt,
        isElectron: Kt,
        isEdgeChromium: Qt,
        isLegacyEdge: Jt,
        isWindows: er,
        isMacOs: tr
      };
    },
    /* 2 */
    /***/
    function(s, p, l) {
      var u;
      /*!
      * UAParser.js v0.7.18
      * Lightweight JavaScript-based User-Agent string parser
      * https://github.com/faisalman/ua-parser-js
      *
      * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
      * Dual licensed under GPLv2 or MIT
      */
      (function(m, c) {
        var n = "0.7.18", v = "", d = "?", h = "function", T = "undefined", O = "object", N = "string", k = "major", i = "model", a = "name", t = "type", e = "vendor", r = "version", g = "architecture", x = "console", w = "mobile", b = "tablet", X = "smarttv", ne = "wearable", ve = "embedded", z = { extend: function(I, P) {
          var E = {};
          for (var A in I)
            P[A] && P[A].length % 2 === 0 ? E[A] = P[A].concat(I[A]) : E[A] = I[A];
          return E;
        }, has: function(I, P) {
          return typeof I == "string" ? P.toLowerCase().indexOf(I.toLowerCase()) !== -1 : !1;
        }, lowerize: function(I) {
          return I.toLowerCase();
        }, major: function(I) {
          return typeof I === N ? I.replace(/[^\d\.]/g, "").split(".")[0] : c;
        }, trim: function(I) {
          return I.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
        } }, W = { rgx: function(I, P) {
          for (var E = 0, A, V, re, M, te, F; E < P.length && !te; ) {
            var ue = P[E], ce = P[E + 1];
            for (A = V = 0; A < ue.length && !te; )
              if (te = ue[A++].exec(I), te)
                for (re = 0; re < ce.length; re++)
                  F = te[++V], M = ce[re], typeof M === O && M.length > 0 ? M.length == 2 ? typeof M[1] == h ? this[M[0]] = M[1].call(this, F) : this[M[0]] = M[1] : M.length == 3 ? typeof M[1] === h && !(M[1].exec && M[1].test) ? this[M[0]] = F ? M[1].call(this, F, M[2]) : c : this[M[0]] = F ? F.replace(M[1], M[2]) : c : M.length == 4 && (this[M[0]] = F ? M[3].call(this, F.replace(M[1], M[2])) : c) : this[M] = F || c;
            E += 2;
          }
        }, str: function(I, P) {
          for (var E in P)
            if (typeof P[E] === O && P[E].length > 0) {
              for (var A = 0; A < P[E].length; A++)
                if (z.has(P[E][A], I))
                  return E === d ? c : E;
            } else if (z.has(P[E], I))
              return E === d ? c : E;
          return I;
        } }, Z = { browser: { oldsafari: { version: { "1.0": "/8", 1.2: "/1", 1.3: "/3", "2.0": "/412", "2.0.2": "/416", "2.0.3": "/417", "2.0.4": "/419", "?": "/" } } }, device: { amazon: { model: { "Fire Phone": ["SD", "KF"] } }, sprint: { model: { "Evo Shift 4G": "7373KT" }, vendor: { HTC: "APA", Sprint: "Sprint" } } }, os: { windows: { version: { ME: "4.90", "NT 3.11": "NT3.51", "NT 4.0": "NT4.0", 2e3: "NT 5.0", XP: ["NT 5.1", "NT 5.2"], Vista: "NT 6.0", 7: "NT 6.1", 8: "NT 6.2", 8.1: "NT 6.3", 10: ["NT 6.4", "NT 10.0"], RT: "ARM" } } } }, le = { browser: [[/(opera\smini)\/([\w\.-]+)/i, /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i, /(opera).+version\/([\w\.]+)/i, /(opera)[\/\s]+([\w\.]+)/i], [a, r], [/(opios)[\/\s]+([\w\.]+)/i], [[a, "Opera Mini"], r], [/\s(opr)\/([\w\.]+)/i], [[a, "Opera"], r], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i, /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i, /(?:ms|\()(ie)\s([\w\.]+)/i, /(rekonq)\/([\w\.]*)/i, /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark)\/([\w\.-]+)/i], [a, r], [/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i], [[a, "IE"], r], [/(edge|edgios|edgea)\/((\d+)?[\w\.]+)/i], [[a, "Edge"], r], [/(yabrowser)\/([\w\.]+)/i], [[a, "Yandex"], r], [/(puffin)\/([\w\.]+)/i], [[a, "Puffin"], r], [/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i], [[a, "UCBrowser"], r], [/(comodo_dragon)\/([\w\.]+)/i], [[a, /_/g, " "], r], [/(micromessenger)\/([\w\.]+)/i], [[a, "WeChat"], r], [/(qqbrowserlite)\/([\w\.]+)/i], [a, r], [/(QQ)\/([\d\.]+)/i], [a, r], [/m?(qqbrowser)[\/\s]?([\w\.]+)/i], [a, r], [/(BIDUBrowser)[\/\s]?([\w\.]+)/i], [a, r], [/(2345Explorer)[\/\s]?([\w\.]+)/i], [a, r], [/(MetaSr)[\/\s]?([\w\.]+)/i], [a], [/(LBBROWSER)/i], [a], [/xiaomi\/miuibrowser\/([\w\.]+)/i], [r, [a, "MIUI Browser"]], [/;fbav\/([\w\.]+);/i], [r, [a, "Facebook"]], [/headlesschrome(?:\/([\w\.]+)|\s)/i], [r, [a, "Chrome Headless"]], [/\swv\).+(chrome)\/([\w\.]+)/i], [[a, /(.+)/, "$1 WebView"], r], [/((?:oculus|samsung)browser)\/([\w\.]+)/i], [[a, /(.+(?:g|us))(.+)/, "$1 $2"], r], [/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i], [r, [a, "Android Browser"]], [/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i], [a, r], [/(dolfin)\/([\w\.]+)/i], [[a, "Dolphin"], r], [/((?:android.+)crmo|crios)\/([\w\.]+)/i], [[a, "Chrome"], r], [/(coast)\/([\w\.]+)/i], [[a, "Opera Coast"], r], [/fxios\/([\w\.-]+)/i], [r, [a, "Firefox"]], [/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i], [r, [a, "Mobile Safari"]], [/version\/([\w\.]+).+?(mobile\s?safari|safari)/i], [r, a], [/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i], [[a, "GSA"], r], [/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i], [a, [r, W.str, Z.browser.oldsafari.version]], [/(konqueror)\/([\w\.]+)/i, /(webkit|khtml)\/([\w\.]+)/i], [a, r], [/(navigator|netscape)\/([\w\.-]+)/i], [[a, "Netscape"], r], [/(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i, /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i, /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i, /(links)\s\(([\w\.]+)/i, /(gobrowser)\/?([\w\.]*)/i, /(ice\s?browser)\/v?([\w\._]+)/i, /(mosaic)[\/\s]([\w\.]+)/i], [a, r]], cpu: [[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i], [[g, "amd64"]], [/(ia32(?=;))/i], [[g, z.lowerize]], [/((?:i[346]|x)86)[;\)]/i], [[g, "ia32"]], [/windows\s(ce|mobile);\sppc;/i], [[g, "arm"]], [/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i], [[g, /ower/, "", z.lowerize]], [/(sun4\w)[;\)]/i], [[g, "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i], [[g, z.lowerize]]], device: [[/\((ipad|playbook);[\w\s\);-]+(rim|apple)/i], [i, e, [t, b]], [/applecoremedia\/[\w\.]+ \((ipad)/], [i, [e, "Apple"], [t, b]], [/(apple\s{0,1}tv)/i], [[i, "Apple TV"], [e, "Apple"]], [/(archos)\s(gamepad2?)/i, /(hp).+(touchpad)/i, /(hp).+(tablet)/i, /(kindle)\/([\w\.]+)/i, /\s(nook)[\w\s]+build\/(\w+)/i, /(dell)\s(strea[kpr\s\d]*[\dko])/i], [e, i, [t, b]], [/(kf[A-z]+)\sbuild\/.+silk\//i], [i, [e, "Amazon"], [t, b]], [/(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i], [[i, W.str, Z.device.amazon.model], [e, "Amazon"], [t, w]], [/\((ip[honed|\s\w*]+);.+(apple)/i], [i, e, [t, w]], [/\((ip[honed|\s\w*]+);/i], [i, [e, "Apple"], [t, w]], [/(blackberry)[\s-]?(\w+)/i, /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i, /(hp)\s([\w\s]+\w)/i, /(asus)-?(\w+)/i], [e, i, [t, w]], [/\(bb10;\s(\w+)/i], [i, [e, "BlackBerry"], [t, w]], [/android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i], [i, [e, "Asus"], [t, b]], [/(sony)\s(tablet\s[ps])\sbuild\//i, /(sony)?(?:sgp.+)\sbuild\//i], [[e, "Sony"], [i, "Xperia Tablet"], [t, b]], [/android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i], [i, [e, "Sony"], [t, w]], [/\s(ouya)\s/i, /(nintendo)\s([wids3u]+)/i], [e, i, [t, x]], [/android.+;\s(shield)\sbuild/i], [i, [e, "Nvidia"], [t, x]], [/(playstation\s[34portablevi]+)/i], [i, [e, "Sony"], [t, x]], [/(sprint\s(\w+))/i], [[e, W.str, Z.device.sprint.vendor], [i, W.str, Z.device.sprint.model], [t, w]], [/(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i], [e, i, [t, b]], [/(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i, /(zte)-(\w*)/i, /(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i], [e, [i, /_/g, " "], [t, w]], [/(nexus\s9)/i], [i, [e, "HTC"], [t, b]], [/d\/huawei([\w\s-]+)[;\)]/i, /(nexus\s6p)/i], [i, [e, "Huawei"], [t, w]], [/(microsoft);\s(lumia[\s\w]+)/i], [e, i, [t, w]], [/[\s\(;](xbox(?:\sone)?)[\s\);]/i], [i, [e, "Microsoft"], [t, x]], [/(kin\.[onetw]{3})/i], [[i, /\./g, " "], [e, "Microsoft"], [t, w]], [/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i, /mot[\s-]?(\w*)/i, /(XT\d{3,4}) build\//i, /(nexus\s6)/i], [i, [e, "Motorola"], [t, w]], [/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i], [i, [e, "Motorola"], [t, b]], [/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i], [[e, z.trim], [i, z.trim], [t, X]], [/hbbtv.+maple;(\d+)/i], [[i, /^/, "SmartTV"], [e, "Samsung"], [t, X]], [/\(dtv[\);].+(aquos)/i], [i, [e, "Sharp"], [t, X]], [/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i, /((SM-T\w+))/i], [[e, "Samsung"], i, [t, b]], [/smart-tv.+(samsung)/i], [e, [t, X], i], [/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i, /(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i, /sec-((sgh\w+))/i], [[e, "Samsung"], i, [t, w]], [/sie-(\w*)/i], [i, [e, "Siemens"], [t, w]], [/(maemo|nokia).*(n900|lumia\s\d+)/i, /(nokia)[\s_-]?([\w-]*)/i], [[e, "Nokia"], i, [t, w]], [/android\s3\.[\s\w;-]{10}(a\d{3})/i], [i, [e, "Acer"], [t, b]], [/android.+([vl]k\-?\d{3})\s+build/i], [i, [e, "LG"], [t, b]], [/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i], [[e, "LG"], i, [t, b]], [/(lg) netcast\.tv/i], [e, i, [t, X]], [/(nexus\s[45])/i, /lg[e;\s\/-]+(\w*)/i, /android.+lg(\-?[\d\w]+)\s+build/i], [i, [e, "LG"], [t, w]], [/android.+(ideatab[a-z0-9\-\s]+)/i], [i, [e, "Lenovo"], [t, b]], [/linux;.+((jolla));/i], [e, i, [t, w]], [/((pebble))app\/[\d\.]+\s/i], [e, i, [t, ne]], [/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i], [e, i, [t, w]], [/crkey/i], [[i, "Chromecast"], [e, "Google"]], [/android.+;\s(glass)\s\d/i], [i, [e, "Google"], [t, ne]], [/android.+;\s(pixel c)\s/i], [i, [e, "Google"], [t, b]], [/android.+;\s(pixel xl|pixel)\s/i], [i, [e, "Google"], [t, w]], [/android.+;\s(\w+)\s+build\/hm\1/i, /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i, /android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i, /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i], [[i, /_/g, " "], [e, "Xiaomi"], [t, w]], [/android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i], [[i, /_/g, " "], [e, "Xiaomi"], [t, b]], [/android.+;\s(m[1-5]\snote)\sbuild/i], [i, [e, "Meizu"], [t, b]], [/android.+a000(1)\s+build/i, /android.+oneplus\s(a\d{4})\s+build/i], [i, [e, "OnePlus"], [t, w]], [/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i], [i, [e, "RCA"], [t, b]], [/android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i], [i, [e, "Dell"], [t, b]], [/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i], [i, [e, "Verizon"], [t, b]], [/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i], [[e, "Barnes & Noble"], i, [t, b]], [/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i], [i, [e, "NuVision"], [t, b]], [/android.+;\s(k88)\sbuild/i], [i, [e, "ZTE"], [t, b]], [/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i], [i, [e, "Swiss"], [t, w]], [/android.+[;\/]\s*(zur\d{3})\s+build/i], [i, [e, "Swiss"], [t, b]], [/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i], [i, [e, "Zeki"], [t, b]], [/(android).+[;\/]\s+([YR]\d{2})\s+build/i, /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i], [[e, "Dragon Touch"], i, [t, b]], [/android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i], [i, [e, "Insignia"], [t, b]], [/android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i], [i, [e, "NextBook"], [t, b]], [/android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i], [[e, "Voice"], i, [t, w]], [/android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i], [[e, "LvTel"], i, [t, w]], [/android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i], [i, [e, "Envizen"], [t, b]], [/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i], [e, i, [t, b]], [/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i], [i, [e, "MachSpeed"], [t, b]], [/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i], [e, i, [t, b]], [/android.+[;\/]\s*TU_(1491)\s+build/i], [i, [e, "Rotor"], [t, b]], [/android.+(KS(.+))\s+build/i], [i, [e, "Amazon"], [t, b]], [/android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i], [e, i, [t, b]], [/\s(tablet|tab)[;\/]/i, /\s(mobile)(?:[;\/]|\ssafari)/i], [[t, z.lowerize], e, i], [/(android[\w\.\s\-]{0,9});.+build/i], [i, [e, "Generic"]]], engine: [[/windows.+\sedge\/([\w\.]+)/i], [r, [a, "EdgeHTML"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i, /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i, /(icab)[\/\s]([23]\.[\d\.]+)/i], [a, r], [/rv\:([\w\.]{1,9}).+(gecko)/i], [r, a]], os: [[/microsoft\s(windows)\s(vista|xp)/i], [a, r], [/(windows)\snt\s6\.2;\s(arm)/i, /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i, /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i], [a, [r, W.str, Z.os.windows.version]], [/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i], [[a, "Windows"], [r, W.str, Z.os.windows.version]], [/\((bb)(10);/i], [[a, "BlackBerry"], r], [/(blackberry)\w*\/?([\w\.]*)/i, /(tizen)[\/\s]([\w\.]+)/i, /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]*)/i, /linux;.+(sailfish);/i], [a, r], [/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i], [[a, "Symbian"], r], [/\((series40);/i], [a], [/mozilla.+\(mobile;.+gecko.+firefox/i], [[a, "Firefox OS"], r], [/(nintendo|playstation)\s([wids34portablevu]+)/i, /(mint)[\/\s\(]?(\w*)/i, /(mageia|vectorlinux)[;\s]/i, /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i, /(hurd|linux)\s?([\w\.]*)/i, /(gnu)\s?([\w\.]*)/i], [a, r], [/(cros)\s[\w]+\s([\w\.]+\w)/i], [[a, "Chromium OS"], r], [/(sunos)\s?([\w\.\d]*)/i], [[a, "Solaris"], r], [/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i], [a, r], [/(haiku)\s(\w+)/i], [a, r], [/cfnetwork\/.+darwin/i, /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i], [[r, /_/g, "."], [a, "iOS"]], [/(mac\sos\sx)\s?([\w\s\.]*)/i, /(macintosh|mac(?=_powerpc)\s)/i], [[a, "Mac OS"], [r, /_/g, "."]], [/((?:open)?solaris)[\/\s-]?([\w\.]*)/i, /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i, /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i, /(unix)\s?([\w\.]*)/i], [a, r]] }, q = function(I, P) {
          if (typeof I == "object" && (P = I, I = c), !(this instanceof q))
            return new q(I, P).getResult();
          var E = I || (m && m.navigator && m.navigator.userAgent ? m.navigator.userAgent : v), A = P ? z.extend(le, P) : le;
          return this.getBrowser = function() {
            var V = { name: c, version: c };
            return W.rgx.call(V, E, A.browser), V.major = z.major(V.version), V;
          }, this.getCPU = function() {
            var V = { architecture: c };
            return W.rgx.call(V, E, A.cpu), V;
          }, this.getDevice = function() {
            var V = { vendor: c, model: c, type: c };
            return W.rgx.call(V, E, A.device), V;
          }, this.getEngine = function() {
            var V = { name: c, version: c };
            return W.rgx.call(V, E, A.engine), V;
          }, this.getOS = function() {
            var V = { name: c, version: c };
            return W.rgx.call(V, E, A.os), V;
          }, this.getResult = function() {
            return { ua: this.getUA(), browser: this.getBrowser(), engine: this.getEngine(), os: this.getOS(), device: this.getDevice(), cpu: this.getCPU() };
          }, this.getUA = function() {
            return E;
          }, this.setUA = function(V) {
            return E = V, this;
          }, this;
        };
        q.VERSION = n, q.BROWSER = { NAME: a, MAJOR: k, VERSION: r }, q.CPU = { ARCHITECTURE: g }, q.DEVICE = { MODEL: i, VENDOR: e, TYPE: t, CONSOLE: x, MOBILE: w, SMARTTV: X, TABLET: b, WEARABLE: ne, EMBEDDED: ve }, q.ENGINE = { NAME: a, VERSION: r }, q.OS = { NAME: a, VERSION: r }, typeof p !== T ? (typeof s !== T && s.exports && (p = s.exports = q), p.UAParser = q) : l(3) ? (u = (function() {
          return q;
        }).call(p, l, p, s), u !== c && (s.exports = u)) : m && (m.UAParser = q);
        var J = m && (m.jQuery || m.Zepto);
        if (typeof J !== T) {
          var ee = new q();
          J.ua = ee.getResult(), J.ua.get = function() {
            return ee.getUA();
          }, J.ua.set = function(I) {
            ee.setUA(I);
            var P = ee.getResult();
            for (var E in P)
              J.ua[E] = P[E];
          };
        }
      })(typeof window == "object" ? window : this);
    },
    /* 3 */
    /***/
    function(s, p) {
      (function(l) {
        s.exports = l;
      }).call(p, {});
    },
    /* 4 */
    /***/
    function(s, p, l) {
      Object.defineProperty(p, "__esModule", {
        value: !0
      });
      var u = Object.assign || function(a) {
        for (var t = 1; t < arguments.length; t++) {
          var e = arguments[t];
          for (var r in e)
            Object.prototype.hasOwnProperty.call(e, r) && (a[r] = e[r]);
        }
        return a;
      }, m = l(0), c = m.DEVICE_TYPES, n = m.defaultData, v = function(t) {
        switch (t) {
          case c.MOBILE:
            return { isMobile: !0 };
          case c.TABLET:
            return { isTablet: !0 };
          case c.SMART_TV:
            return { isSmartTV: !0 };
          case c.CONSOLE:
            return { isConsole: !0 };
          case c.WEARABLE:
            return { isWearable: !0 };
          case c.BROWSER:
            return { isBrowser: !0 };
          default:
            return n;
        }
      }, d = function(t, e, r, g, x) {
        return {
          isBrowser: t,
          browserMajorVersion: e.major,
          browserFullVersion: e.version,
          browserName: e.name,
          engineName: r.name || !1,
          engineVersion: r.version,
          osName: g.name,
          osVersion: g.version,
          userAgent: x
        };
      }, h = function(t, e, r, g) {
        return u({}, t, {
          vendor: e.vendor,
          model: e.model,
          os: r.name,
          osVersion: r.version,
          ua: g
        });
      }, T = function(t, e, r, g) {
        return {
          isSmartTV: t,
          engineName: e.name,
          engineVersion: e.version,
          osName: r.name,
          osVersion: r.version,
          userAgent: g
        };
      }, O = function(t, e, r, g) {
        return {
          isConsole: t,
          engineName: e.name,
          engineVersion: e.version,
          osName: r.name,
          osVersion: r.version,
          userAgent: g
        };
      }, N = function(t, e, r, g) {
        return {
          isWearable: t,
          engineName: e.name,
          engineVersion: e.version,
          osName: r.name,
          osVersion: r.version,
          userAgent: g
        };
      }, k = p.getNavigatorInstance = function() {
        return typeof window < "u" && (window.navigator || navigator) ? window.navigator || navigator : !1;
      }, i = p.isIOS13Check = function(t) {
        var e = k();
        return e && e.platform && (e.platform.indexOf(t) !== -1 || e.platform === "MacIntel" && e.maxTouchPoints > 1 && !window.MSStream);
      };
      s.exports = {
        checkType: v,
        broPayload: d,
        mobilePayload: h,
        stvPayload: T,
        consolePayload: O,
        wearPayload: N,
        getNavigatorInstance: k,
        isIOS13Check: i
      };
    }
    /******/
  ]);
})(Ve);
var Pr = Ve.exports;
const Mr = ["src"], ae = 4, Ar = /* @__PURE__ */ $({
  __name: "ZoomImage",
  props: {
    imageUrl: {
      type: String,
      required: !0
    },
    zoomable: {
      type: Boolean,
      required: !1,
      default: !0
    }
  },
  emits: ["openFullScreenPictures"],
  setup(o, { emit: s }) {
    pe((g) => ({
      "2b73d592": l.value,
      "06d6b304": u.value,
      "5898d630": m.value,
      "72474c7e": c.value
    }));
    const p = o, l = D(1), u = D("0%"), m = D("0%"), c = B(() => l.value > ae - 1 && l.value <= ae ? "zoom-out" : "zoom-in"), n = s, {
      promise: v,
      reject: d,
      accept: h
    } = Ae(), T = v(), O = d(), N = h(() => {
      n("openFullScreenPictures");
    });
    function k() {
      return Pr.isMobile || !p.zoomable;
    }
    function i(g) {
      k() || g.button === 0 && (l.value = Math.ceil(l.value) % ae + 1);
    }
    function a(g) {
      if (k()) return;
      const x = g.target, w = g.offsetX / x.clientWidth * 100 - 50, b = g.offsetY / x.clientHeight * 100 - 50;
      u.value = w * -1 + "%", m.value = b * -1 + "%";
    }
    function t(g) {
      if (k()) return;
      let x = l.value -= g.deltaY / 200;
      x < 1 ? x = 1 : x > ae && (x = ae), l.value = x;
    }
    function e() {
      k();
    }
    function r() {
      k() || (l.value = 1, u.value = "0%", m.value = "0%");
    }
    return (g, x) => (f(), y("div", {
      onMouseenter: e,
      onMousemove: a,
      onMouseleave: r,
      onWheelCapture: ir(t, ["stop", "prevent"]),
      onMousedown: i,
      class: ie(["main-image-container", { zoomable: o.zoomable }])
    }, [
      C("div", {
        class: "mobile-fullscreen-opener",
        onPointerdown: x[0] || (x[0] = //@ts-ignore
        (...w) => S(T) && S(T)(...w)),
        onPointermoveCapture: x[1] || (x[1] = //@ts-ignore
        (...w) => S(O) && S(O)(...w)),
        onPointerup: x[2] || (x[2] = //@ts-ignore
        (...w) => S(N) && S(N)(...w))
      }, null, 32),
      C("img", {
        src: o.imageUrl,
        class: "product-image"
      }, null, 8, Mr)
    ], 34));
  }
}), Vr = /* @__PURE__ */ L(Ar, [["__scopeId", "data-v-37458a2f"]]);
function Nr(o) {
  const s = ke({ width: 0, height: 0, scrollWidth: 0, scrollHeight: 0 });
  function p() {
    var m, c, n, v;
    return s.width = ((m = o.value) == null ? void 0 : m.clientWidth) ?? 0, s.height = ((c = o.value) == null ? void 0 : c.clientHeight) ?? 0, s.scrollWidth = ((n = o.value) == null ? void 0 : n.scrollWidth) ?? 0, s.scrollHeight = ((v = o.value) == null ? void 0 : v.scrollHeight) ?? 0, s;
  }
  function l() {
    window.addEventListener("resize", p);
  }
  function u() {
    window.removeEventListener("resize", p);
  }
  return { size: s, follow: l, stop: u, updateSize: p };
}
const Br = ["id"], Rr = ["id", "innerHTML"], Dr = /* @__PURE__ */ $({
  __name: "ProductImage",
  props: {
    blocks: {
      type: Array,
      required: !0
    },
    images: {
      type: Array,
      required: !0
    },
    disableVCarousel: {
      type: Boolean,
      required: !0
    },
    selectedVariant: {
      type: {},
      required: !0
    }
  },
  setup(o) {
    pe((e) => ({
      32103673: S(c).height
    }));
    const { getBlock: s, blockAttributes: p } = Ce(), l = o, u = D(!1), m = D(null), {
      size: c,
      follow: n,
      stop: v,
      updateSize: d
    } = Nr(m);
    function h(e) {
      t.value = N.value[e];
    }
    const T = B(() => s(Pe, l.blocks)), O = B(() => s(
      Me,
      l.blocks
    )), N = B(() => l.images.map((e) => e.src)), k = B(() => !l.disableVCarousel && N.value.length > 1), i = B(() => l.disableVCarousel ? !(!T.value || T.value.settings.minimum_zoom_price > l.selectedVariant.price / 100) : !0);
    function a() {
      let e = l.selectedVariant.featured_image.position;
      return l.selectedVariant.featured_image.id || (e = 0), N.value[e];
    }
    const t = D(a());
    return me(l, () => {
      t.value = a();
    }), we(() => {
      n(), d();
    }), Oe(() => {
      v();
    }), (e, r) => T.value ? (f(), y("div", j({
      key: 0,
      id: T.value.id,
      class: "product-image"
    }, S(p)(T.value.shopify_attributes)), [
      k.value ? (f(), U(S(ge), {
        key: 0,
        class: "vertical-carousel hide-mobile",
        imgsUrls: N.value,
        onSelectPicture: r[0] || (r[0] = (g) => h(g))
      }, null, 8, ["imgsUrls"])) : R("", !0),
      C("div", {
        ref_key: "mainImageColumn",
        ref: m,
        class: "main-image-column"
      }, [
        H(S(Vr), {
          class: ie(["main-image", { loner: !k.value }]),
          imageUrl: t.value,
          zoomable: i.value,
          onOpenFullScreenPictures: r[1] || (r[1] = (g) => u.value = !0)
        }, null, 8, ["class", "imageUrl", "zoomable"]),
        k.value ? (f(), U(S(ge), {
          key: 0,
          vertical: !1,
          class: "horizontal-carousel hide-desktop",
          imgsUrls: N.value,
          onSelectPicture: r[2] || (r[2] = (g) => h(g))
        }, null, 8, ["imgsUrls"])) : R("", !0),
        O.value ? (f(), y("p", j({
          key: 1,
          class: "image-additional-info user-content",
          id: O.value.id,
          innerHTML: O.value.settings.content
        }, S(p)(O.value.shopify_attributes)), null, 16, Rr)) : R("", !0)
      ], 512),
      (f(), U(sr, { to: "body" }, [
        H(nr, {
          appear: !0,
          name: "fade"
        }, {
          default: or(() => [
            u.value ? (f(), U(S(Cr), {
              key: 0,
              onClose: r[3] || (r[3] = (g) => u.value = !1),
              "imgs-urls": N.value,
              displayCarousel: k.value,
              "opened-image": t.value
            }, null, 8, ["imgs-urls", "displayCarousel", "opened-image"])) : R("", !0)
          ]),
          _: 1
        })
      ]))
    ], 16, Br)) : R("", !0);
  }
}), $r = /* @__PURE__ */ L(Dr, [["__scopeId", "data-v-ce1945f8"]]), Lr = ["href"], Ur = ["alt", "src"], qr = /* @__PURE__ */ $({
  __name: "TCGExpansionBadge",
  props: {
    logo: {
      type: String,
      required: !1
    },
    alt: {
      type: String,
      required: !0
    },
    handle: {
      type: String,
      required: !0
    },
    filtered_url: {
      type: String,
      required: !0
    }
  },
  setup(o) {
    const s = o;
    return (p, l) => (f(), y("a", {
      href: o.filtered_url ?? ""
    }, [
      C("img", {
        class: "tcg-logo",
        alt: o.alt ?? "",
        src: s.logo
      }, null, 8, Ur)
    ], 8, Lr));
  }
}), Wr = /* @__PURE__ */ L(qr, [["__scopeId", "data-v-756e14c8"]]), zr = { class: "product-name" }, Fr = { class: "main-infos" }, jr = { class: "product-title" }, Hr = /* @__PURE__ */ $({
  __name: "ProductName",
  props: {
    metaTcg: {
      type: {},
      required: !1
    },
    title: {
      type: String,
      required: !0
    },
    settings: {
      type: {},
      required: !0
    }
  },
  setup(o) {
    const s = o, p = B(() => {
      var l, u;
      return (u = (l = s.metaTcg) == null ? void 0 : l.expansion) == null ? void 0 : u.logo;
    });
    return (l, u) => (f(), y("div", zr, [
      C("div", Fr, [
        C("h1", jr, Y(o.title), 1),
        p.value ? (f(), U(Wr, {
          key: 0,
          class: "expansion-badge",
          logo: o.metaTcg.expansion.logo,
          alt: o.metaTcg.expansion.name,
          handle: o.metaTcg.expansion.handle,
          filtered_url: o.metaTcg.expansion.filtered_url
        }, null, 8, ["logo", "alt", "handle", "filtered_url"])) : R("", !0)
      ])
    ]));
  }
}), Yr = /* @__PURE__ */ L(Hr, [["__scopeId", "data-v-061db424"]]), Gr = { class: "product-price" }, Xr = { class: "price" }, Zr = /* @__PURE__ */ $({
  __name: "ProductPrice",
  props: {
    selectedVariantPrice: {
      type: Number,
      required: !0
    },
    selectedVariantAvailable: {
      type: Boolean,
      required: !0
    },
    selectedVariantComparePrice: { 
      type: Number, 
      required: !1 
    } // ← new
  },
  setup(o) {
    const s = o, { formatMoney: p } = mr(), l = B(() => p(s.selectedVariantPrice));
    const c = B(() => s.selectedVariantComparePrice ? p(s.selectedVariantComparePrice) : null);
    const showCompare = B(() =>
      s.selectedVariantComparePrice &&
      s.selectedVariantComparePrice > s.selectedVariantPrice
    );
    return (u, m) => (
      f(),
      y("div", Gr, [
        C("h2", Xr, Y(l.value), 1),
        s.selectedVariantComparePrice && s.selectedVariantComparePrice > s.selectedVariantPrice
          ? (f(), y("span", { class: "compare-price" }, Y(c.value), 1))
          : R("", !0)
      ])
    );
  }
}), Kr = /* @__PURE__ */ L(Zr, [["__scopeId", "data-v-f9ef92f6"]]), Qr = { class: "separator" }, Jr = /* @__PURE__ */ $({
  __name: "DottedSeparator",
  props: {
    settings: {
      type: {},
      required: !0
    }
  },
  setup(o) {
    return pe((s) => ({
      "09cf0e4a": o.settings.color
    })), (s, p) => (f(), y("span", Qr));
  }
}), ei = /* @__PURE__ */ L(Jr, [["__scopeId", "data-v-2f34b91a"]]), ti = { class: "product-desription" }, ri = { class: "description-title" }, ii = ["innerHTML"], si = /* @__PURE__ */ $({
  __name: "ProductDescription",
  props: {
    content: {
      type: String,
      required: !0
    },
    metaTcg: {
      type: {},
      required: !1
    }
  },
  setup(o) {
    const s = o;
    function p() {
      var h;
      if (!((h = s.metaTcg) != null && h.expansion)) return "";
      const c = ["name", "serie", "release_year", "reference"], n = Object.keys(s.metaTcg.expansion).values(), v = Object.keys(u.product.tcg.expansion);
      let d = "";
      for (const T of n)
        !v.includes(T) || !c.includes(T) || //@ts-expect-error key is derived from props.metaTcg.expansion, it'll always be valid.
        !s.metaTcg.expansion[T] || (d += `${u.product.tcg.expansion[T]}: ${s.metaTcg.expansion[T]}<br/>`);
      return d;
    }
    const l = B(() => {
      if (!s.metaTcg) return "";
      const c = Object.keys(s.metaTcg).values(), n = Object.keys(u.product.tcg);
      let v = "<p>";
      for (const d of c)
        !n.includes(d) || !s.metaTcg[d] || (d == "expansion" ? v += p() : v += `${u.product.tcg[d]}: ${s.metaTcg[d]}<br/>`);
      return v + "</p>";
    }), { t: u } = Ie(), m = u.general.description;
    return (c, n) => (f(), y("div", ti, [
      C("p", ri, Y(S(m)), 1),
      C("span", {
        class: "user-content content",
        innerHTML: o.content + l.value
      }, null, 8, ii)
    ]));
  }
}), ni = /* @__PURE__ */ L(si, [["__scopeId", "data-v-c6726041"]]), oi = ["innerHTML"], ai = /* @__PURE__ */ $({
  __name: "AdditionalInfos",
  props: {
    content: {
      type: String,
      required: !0
    }
  },
  setup(o) {
    return (s, p) => (f(), y("div", {
      class: "product-additional-infos user-content",
      innerHTML: o.content
    }, null, 8, oi));
  }
}), li = { class: "omikujies-waranties" }, ui = {
  key: 0,
  class: "row"
}, ci = {
  key: 1,
  class: "separator"
}, di = {
  key: 2,
  class: "row"
}, pi = /* @__PURE__ */ $({
  __name: "OmikujisWaranties",
  props: {
    settings: {
      type: {},
      required: !0
    }
  },
  setup(o) {
    const s = o, p = B(() => {
      const n = s.settings.higher_block.filter((v) => v !== "");
      return n.length ? n : null;
    }), l = B(() => {
      const n = s.settings.lower_block.filter((v) => v !== "");
      return n.length ? n : null;
    }), u = B(() => p.value && l.value);
    return (m, c) => (f(), y("div", li, [
      p.value ? (f(), y("div", ui, [
        (f(!0), y(Q, null, se(p.value, (n) => (f(), y("p", { key: n }, Y(n), 1))), 128))
      ])) : R("", !0),
      u.value ? (f(), y("div", ci)) : R("", !0),
      l.value ? (f(), y("div", di, [
        (f(!0), y(Q, null, se(l.value, (n) => (f(), y("p", { key: n }, Y(n), 1))), 128))
      ])) : R("", !0)
    ]));
  }
}), mi = /* @__PURE__ */ L(pi, [["__scopeId", "data-v-aaa6d40b"]]), vi = { class: "product-brand-and-collection" }, fi = ["href"], gi = ["href"], wi = /* @__PURE__ */ $({
  __name: "BrandNCollection",
  props: {
    brand: {
      type: {},
      required: !0
    },
    collection: {
      type: {},
      required: !0
    }
  },
  setup(o) {
    return (s, p) => (f(), y("div", vi, [
      o.brand.text ? (f(), y("a", {
        key: 0,
        class: "product-brand",
        href: `${o.brand.url}?${o.brand.filter}=${o.brand.text}`
      }, Y(o.brand.text), 9, fi)) : R("", !0),
      C("a", {
        class: "product-collection",
        href: o.collection.url
      }, Y(o.collection.text), 9, gi)
    ]));
  }
}), bi = /* @__PURE__ */ L(wi, [["__scopeId", "data-v-3938bed9"]]), yi = {}, hi = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "11",
  viewBox: "0 0 18 11",
  fill: "none"
};
function _i(o, s) {
  return f(), y("svg", hi, s[0] || (s[0] = [
    C("path", {
      d: "M17 1.17969L9 9.82053L1 1.17969",
      stroke: "#01203F",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const Ti = /* @__PURE__ */ L(yi, [["render", _i]]), Ne = Symbol(), Be = Symbol(), Si = Symbol(), Ei = { class: "dropdown-header" }, Oi = { class: "drop-menu-wrapper" }, ki = { class: "drop-menu" }, xi = ["onPointerup"], Ii = /* @__PURE__ */ $({
  __name: "OptionsDropDown",
  props: {
    option: {
      type: {},
      required: !0
    },
    defaultOptionId: {
      type: Number,
      required: !0
    },
    maxOptionsDisplayed: {
      type: Number,
      required: !1,
      default: 3
    },
    displayOutOfStockOption: {
      type: Boolean,
      required: !0
    }
  },
  setup(o) {
    pe((h) => ({
      a3c83340: d.value
    }));
    const s = o, p = xe(Ne), l = D(!1), u = D(
      s.option.values.find((h) => h.id == s.defaultOptionId) ?? s.option.values[0]
    );
    function m(h, T) {
      return !(T.id == u.value.id || !s.displayOutOfStockOption && !T.available);
    }
    function c(h) {
      l.value || (l.value = !0, document.addEventListener("pointerup", v), h.stopImmediatePropagation());
    }
    function n(h, T, O) {
      l.value && (h.stopImmediatePropagation(), s.option.values[O].available && (p(s.option.position, T), u.value = s.option.values[O], Ee(() => {
        v();
      })));
    }
    function v() {
      l.value && (document.removeEventListener("pointerup", v), l.value = !1);
    }
    const d = B(() => s.maxOptionsDisplayed == 0 ? s.option.values.length : Math.min(s.option.values.length, s.maxOptionsDisplayed));
    return (h, T) => (f(), y("div", {
      class: ie(["variant-dropdown", { opened: l.value }]),
      onPointerup: c
    }, [
      C("div", Ei, [
        C("span", {
          class: ie(["entry", { available: u.value.available }])
        }, Y(u.value.name), 3),
        H(Ti, { class: "arrow" })
      ]),
      C("div", Oi, [
        C("div", ki, [
          (f(!0), y(Q, null, se(o.option.values, (O, N) => (f(), y(Q, { key: N }, [
            m(N, O) ? (f(), y("span", {
              key: 0,
              class: ie(["entry", { available: O.available }]),
              onPointerup: (k) => n(k, O.id, N)
            }, Y(O.name), 43, xi)) : R("", !0)
          ], 64))), 128))
        ])
      ])
    ], 34));
  }
}), Ci = /* @__PURE__ */ L(Ii, [["__scopeId", "data-v-25db6b64"]]), Pi = {
  key: 0,
  class: "variant-selector"
}, Mi = { class: "option-name" }, Ai = /* @__PURE__ */ $({
  __name: "VariantSelector",
  props: {
    variants: {
      type: Array,
      required: !0
    },
    options: {
      type: Array,
      required: !0
    },
    genericSettings: {
      type: {},
      required: !0
    }
  },
  setup(o) {
    const s = xe(Be), p = o, l = B(() => p.genericSettings), u = B(() => p.variants.length > 1);
    return (m, c) => u.value ? (f(), y("div", Pi, [
      (f(!0), y(Q, null, se(o.options, (n, v) => (f(), y("div", {
        class: "option",
        key: v,
        style: ar(`z-index:${o.options.length - v};`)
      }, [
        C("span", Mi, Y(n.name) + ": ", 1),
        H(Ci, {
          class: "option-dropdown",
          option: n,
          "default-option-id": S(s)[v],
          "max-options-displayed": l.value.max_element_displayed,
          "display-out-of-stock-option": l.value.display_unavailable_variants
        }, null, 8, ["option", "default-option-id", "max-options-displayed", "display-out-of-stock-option"])
      ], 4))), 128))
    ])) : R("", !0);
  }
}), Vi = /* @__PURE__ */ L(Ai, [["__scopeId", "data-v-b2dceb53"]]), Ni = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let Bi = (o = 21) => {
  let s = "", p = crypto.getRandomValues(new Uint8Array(o));
  for (; o--; )
    s += Ni[p[o] & 63];
  return s;
};
const Ri = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none"
}, Di = ["id"], $i = ["mask"], Li = /* @__PURE__ */ $({
  __name: "ShopingBag",
  setup(o) {
    const s = B(() => "sb-mask-" + Bi());
    return (p, l) => (f(), y("svg", Ri, [
      C("mask", {
        id: s.value,
        style: { "mask-type": "alpha" },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "25",
        height: "24"
      }, l[0] || (l[0] = [
        C("rect", {
          x: "0.5",
          width: "24",
          height: "24",
          fill: "#D9D9D9"
        }, null, -1)
      ]), 8, Di),
      C("g", {
        mask: `url(#${s.value})`
      }, l[1] || (l[1] = [
        C("path", {
          class: "bag",
          d: "M6.5 22C5.95 22 5.47917 21.8042 5.0875 21.4125C4.69583 21.0208 4.5 20.55 4.5 20V8C4.5 7.45 4.69583 6.97917 5.0875 6.5875C5.47917 6.19583 5.95 6 6.5 6H8.5C8.5 4.9 8.89167 3.95833 9.675 3.175C10.4583 2.39167 11.4 2 12.5 2C13.6 2 14.5417 2.39167 15.325 3.175C16.1083 3.95833 16.5 4.9 16.5 6H18.5C19.05 6 19.5208 6.19583 19.9125 6.5875C20.3042 6.97917 20.5 7.45 20.5 8V20C20.5 20.55 20.3042 21.0208 19.9125 21.4125C19.5208 21.8042 19.05 22 18.5 22H6.5ZM6.5 20H18.5V8H16.5V10C16.5 10.2833 16.4042 10.5208 16.2125 10.7125C16.0208 10.9042 15.7833 11 15.5 11C15.2167 11 14.9792 10.9042 14.7875 10.7125C14.5958 10.5208 14.5 10.2833 14.5 10V8H10.5V10C10.5 10.2833 10.4042 10.5208 10.2125 10.7125C10.0208 10.9042 9.78333 11 9.5 11C9.21667 11 8.97917 10.9042 8.7875 10.7125C8.59583 10.5208 8.5 10.2833 8.5 10V8H6.5V20ZM10.5 6H14.5C14.5 5.45 14.3042 4.97917 13.9125 4.5875C13.5208 4.19583 13.05 4 12.5 4C11.95 4 11.4792 4.19583 11.0875 4.5875C10.6958 4.97917 10.5 5.45 10.5 6Z"
        }, null, -1)
      ]), 8, $i)
    ]));
  }
}), Ui = { class: "add-to-cart tpa_product_form" }, qi = ["disabled"], Wi = {
  key: 0,
  class: "shoping-bag"
}, zi = ["innerHTML"], Fi = /* @__PURE__ */ $({
  __name: "AddToCart",
  props: /* @__PURE__ */ lr({
    selectedVariant: {
      type: {},
      required: !0
    }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(o) {
    const { publish: s } = vr(), { add: p, get: l } = pr(), u = o;
    D(null);
    const m = D(!1), { t: c } = Ie(), n = ur(o, "modelValue"), v = D(!1), d = D("");
    me(
      u,
      () => {
        u.selectedVariant.available ? (n.value = u.selectedVariant.id, m.value = !0) : (n.value = void 0, m.value = !1);
      },
      { immediate: !0 }
    );
    const h = B(() => m.value ? c.general.i_m_adding_to_cart + " 🡒" : c.general.out_of_stock);
    async function T() {
      if (n.value == null || v.value) return;
      d.value = "", v.value = !0;
      const O = await p(n.value, 1);
      v.value = !1, O.success ? window.location = "/cart" : d.value = O.reason;
    }
    return (O, N) => (f(), y("div", Ui, [
      C("button", {
        class: "ui-kit-btn-2 button",
        onPointerup: T,
        disabled: !m.value || v.value
      }, [
        m.value ? (f(), y("span", Wi, [
          H(Li)
        ])) : R("", !0),
        C("span", { innerHTML: h.value }, null, 8, zi)
      ], 40, qi),
      d.value ? (f(), U(gr, {
        key: 0,
        class: "error-line",
        value: d.value
      }, null, 8, ["value"])) : R("", !0)
    ]));
  }
}), ji = /* @__PURE__ */ L(Fi, [["__scopeId", "data-v-1c348040"]]), Hi = { class: "product-details" }, Yi = /* @__PURE__ */ $({
  __name: "ProductDetails",
  props: {
    blocks: {
      type: Array,
      required: !0
    },
    variables: {
      type: {},
      required: !0
    },
    selectedVariant: {
      type: {},
      required: !0
    }
  },
  setup(o) {
    const s = o, { blockAttributes: p } = Ce(), l = D(s.selectedVariant.price), u = D(s.selectedVariant.available);
    // Cache for fetched product data
    const productDataCache = new Map();
    
    // Helper function to normalize compare_at_price value (handle both string and number)
    function normalizeCompareAtPrice(value) {
      if (!value && value !== 0) return null;
      
      // Handle string like "19.99" or "19" - convert from dollars to cents
      if (typeof value === 'string') {
        const num = parseFloat(value);
        return isNaN(num) || num <= 0 ? null : Math.round(num * 100);
      }
      
      // Handle number - if it's already in cents (large number like 1999), return as is
      // If it's in dollars (small number like 19.99), convert to cents
      if (typeof value === 'number') {
        // If the number is > 100, assume it's already in cents
        if (value > 100) {
          return value;
        }
        // Otherwise convert from dollars to cents
        return Math.round(value * 100);
      }
      
      return null;
    }
    
    // Helper function to get compare_at_price from various sources
    function getCompareAtPrice(variantId) {
      console.log('[ProductPrice] Looking for compare_at_price for variant:', variantId);
      
      // First try selectedVariant if it has compare_at_price
      const selectedCompare = normalizeCompareAtPrice(s.selectedVariant.compare_at_price);
      if (selectedCompare !== null) {
        console.log('[ProductPrice] Using compare_at_price from selectedVariant:', selectedCompare);
        return selectedCompare;
      }
      
      // Try variants array from props (liquid.variables.variants)
      if (s.variables?.variants && Array.isArray(s.variables.variants)) {
        console.log('[ProductPrice] Checking variants array, count:', s.variables.variants.length);
        const variant = s.variables.variants.find(v => v.id === variantId);
        if (variant) {
          console.log('[ProductPrice] Found variant in array:', variant.id);
          console.log('[ProductPrice] Variant object keys:', Object.keys(variant));
          console.log('[ProductPrice] Full variant object:', variant);
          const comparePrice = normalizeCompareAtPrice(variant.compare_at_price);
          if (comparePrice !== null) {
            console.log('[ProductPrice] Using compare_at_price from variants array:', comparePrice);
            return comparePrice;
          }
        } else {
          console.log('[ProductPrice] Variant', variantId, 'not found in variants array');
        }
      }
      
      // Try window.meta.product.variants
      if (typeof window !== 'undefined' && window.meta?.product?.variants) {
        const variant = window.meta.product.variants.find(v => v.id === variantId);
        const comparePrice = normalizeCompareAtPrice(variant?.compare_at_price);
        if (comparePrice !== null) {
          console.log('[ProductPrice] Using compare_at_price from window.meta:', comparePrice);
          return comparePrice;
        }
      }
      
      // Try window.__SHOPIFY_STATE__.product.variants
      if (typeof window !== 'undefined' && window.__SHOPIFY_STATE__?.product?.variants) {
        const variant = window.__SHOPIFY_STATE__.product.variants.find(v => v.id === variantId);
        const comparePrice = normalizeCompareAtPrice(variant?.compare_at_price);
        if (comparePrice !== null) {
          console.log('[ProductPrice] Using compare_at_price from __SHOPIFY_STATE__:', comparePrice);
          return comparePrice;
        }
      }
      
      // Try ShopifyAnalytics.meta.product.variants
      if (typeof window !== 'undefined' && window.ShopifyAnalytics?.meta?.product?.variants) {
        const variant = window.ShopifyAnalytics.meta.product.variants.find(v => v.id === variantId);
        const comparePrice = normalizeCompareAtPrice(variant?.compare_at_price);
        if (comparePrice !== null) {
          console.log('[ProductPrice] Using compare_at_price from ShopifyAnalytics:', comparePrice);
          return comparePrice;
        }
      }
      
      console.log('[ProductPrice] No compare_at_price found for variant:', variantId);
      return null;
    }
    
    // Async helper to fetch compare_at_price from Shopify API
    async function fetchCompareAtPrice(variantId) {
      // Check cache first
      if (productDataCache.has('variants')) {
        const variant = productDataCache.get('variants').find(v => v.id === variantId);
        const comparePrice = normalizeCompareAtPrice(variant?.compare_at_price);
        if (comparePrice !== null) {
          console.log('[ProductPrice] Using compare_at_price from cache:', comparePrice);
          return comparePrice;
        }
      }
      
      try {
        // Get product handle from current URL
        const urlMatch = window.location.pathname.match(/\/products\/([^\/]+)/);
        if (!urlMatch) {
          console.log('[ProductPrice] Could not extract product handle from URL');
          return null;
        }
        
        const productHandle = urlMatch[1];
        console.log('[ProductPrice] Fetching product data for:', productHandle);
        
        const response = await fetch(`/products/${productHandle}.js`);
        if (!response.ok) {
          console.log('[ProductPrice] Failed to fetch product data:', response.status);
          return null;
        }
        
        const productData = await response.json();
        console.log('[ProductPrice] Fetched product data:', productData);
        
        // Cache the variants (use product.variants if response is wrapped)
        const variants = productData.product?.variants || productData.variants;
        productDataCache.set('variants', variants);
        
        // Find the variant
        const variant = variants.find(v => v.id === variantId);
        console.log('[ProductPrice] Found variant in API response, compare_at_price (raw):', variant?.compare_at_price, typeof variant?.compare_at_price);
        const comparePrice = normalizeCompareAtPrice(variant?.compare_at_price);
        if (comparePrice !== null) {
          console.log('[ProductPrice] Using compare_at_price from API (normalized):', comparePrice);
          return comparePrice;
        }
      } catch (error) {
        console.log('[ProductPrice] Error fetching product data:', error);
      }
      
      return null;
    }
    
    const c = D(getCompareAtPrice(s.selectedVariant.id));
    
    // Always try to fetch compare_at_price from API since liquid.variables doesn't include it
    fetchCompareAtPrice(s.selectedVariant.id).then(price => {
      if (price) {
        console.log('[ProductPrice] Fetched and set compare_at_price:', price);
        c.value = price;
      }
    });
    
    // When variant changes, try to fetch compare_at_price if not found
    return me(s, () => {
      l.value = s.selectedVariant.price;
      u.value = s.selectedVariant.available;
      
      // First try synchronous lookup
      let comparePrice = getCompareAtPrice(s.selectedVariant.id);
      
      // If not found, try async fetch (don't await, let it update when ready)
      if (!comparePrice) {
        fetchCompareAtPrice(s.selectedVariant.id).then(price => {
          if (price) {
            c.value = price;
          }
        });
      } else {
        c.value = comparePrice;
      }
    }), (m, v) => (f(), y("div", Hi, [
      (f(!0), y(Q, null, se(o.blocks, (n, v) => (f(), y(Q, { key: v }, [
        n.type == "brand_n_collection" ? (f(), U(bi, j({
          key: 0,
          id: n.id,
          class: "block under",
          brand: o.variables.brand,
          collection: o.variables.collection,
          ref_for: !0
        }, S(p)(n.shopify_attributes)), null, 16, ["id", "brand", "collection"])) : n.type == "product_name" ? (f(), U(S(Yr), j({
          key: 1,
          id: n.id,
          class: "block under",
          title: o.variables.title,
          "meta-tcg": o.variables.meta.tcg,
          settings: n.settings,
          ref_for: !0
        }, S(p)(n.shopify_attributes)), null, 16, ["id", "title", "meta-tcg", "settings"])) : n.type == "product_price" ? (f(), U(Kr, j({
          key: 2,
          id: n.id,
          class: "block under",
          "selected-variant-price": l.value,
          "selected-variant-available": u.value,
          "selected-variant-compare-price": c.value,
          ref_for: !0
        }, S(p)(n.shopify_attributes)), null, 16, ["id", "selected-variant-price", "selected-variant-available"])) : n.type == "separator" ? (f(), U(ei, j({
          key: 3,
          id: n.id,
          class: "block under",
          settings: n.settings,
          ref_for: !0
        }, S(p)(n.shopify_attributes)), null, 16, ["id", "settings"])) : n.type == "variant_selector" ? (f(), U(S(Vi), j({
          key: 4,
          id: n.id,
          class: "block over",
          variants: o.variables.variants,
          options: o.variables.options,
          "generic-settings": n.settings,
          ref_for: !0
        }, S(p)(n.shopify_attributes)), null, 16, ["id", "variants", "options", "generic-settings"])) : n.type == "add_to_cart_button" ? (f(), U(ji, j({
          key: 5,
          id: n.id,
          class: "block under",
          "selected-variant": o.selectedVariant,
          ref_for: !0
        }, S(p)(n.shopify_attributes)), null, 16, ["id", "selected-variant"])) : n.type == "description" ? (f(), U(ni, j({
          key: 6,
          id: n.id,
          class: "block under",
          "meta-tcg": o.variables.meta.tcg,
          content: o.variables.description,
          ref_for: !0
        }, S(p)(n.shopify_attributes)), null, 16, ["id", "meta-tcg", "content"])) : n.type == "r_column_additional_infos" ? (f(), U(ai, j({
          key: 7,
          id: n.id,
          class: "block under",
          content: String(n.settings.content),
          ref_for: !0
        }, S(p)(n.shopify_attributes)), null, 16, ["id", "content"])) : n.type == "omikujis_waranties" ? (f(), U(mi, j({
          key: 8,
          id: n.id,
          class: "block under",
          settings: n.settings,
          ref_for: !0
        }, S(p)(n.shopify_attributes)), null, 16, ["id", "settings"])) : R("", !0)
      ], 64))), 128))
    ]));
  }
}), Gi = /* @__PURE__ */ L(Yi, [["__scopeId", "data-v-8c9766be"]]);
function Xi(o, s, p) {
  const l = /* @__PURE__ */ new Map(), u = D(
    o.find((d) => d.id == p) ?? o[0]
  ), m = s.map((d) => d.values.map((h) => h.id)), c = ke(
    (() => {
      const d = new Array();
      return d.push(...u.value.options_ids), d;
    })()
  );
  me(c, () => {
    const d = n(c);
    l.has(d) && (u.value = l.get(d));
  });
  function n(d) {
    return d.toSorted().reduce((h, T) => h + T.toString() + " ", "").trim().replace(" ", "_");
  }
  for (const d of o) {
    const h = n(d.options_ids);
    l.set(h, d);
  }
  function v(d, h) {
    if (d < 0 || d >= m.length)
      throw new Error("Out of range position.");
    if (!m[d].includes(h)) throw new Error("Invalid value");
    c[d] = h;
  }
  return { selectOption: v, selectedVariant: u, selectedOptionsIds: c };
}
const Zi = { class: "product-sheet" }, Ki = /* @__PURE__ */ $({
  __name: "ProductSheet",
  props: {
    tcg: {
      type: Boolean,
      required: !1,
      default: !1
    },
    designMode: {
      type: Boolean,
      required: !1
    },
    liquid: {
      type: {},
      required: !0
    }
  },
  setup(o) {
    const s = B(() => m.filter((d) => br.includes(d.type))), p = B(() => m.filter((d) => wr.includes(d.type))), l = o, u = l.liquid.variables, m = l.liquid.blocks, { selectOption: c, selectedVariant: n, selectedOptionsIds: v } = Xi(
      u.variants,
      u.options,
      u.default_variant_id
    );
    return fe(Ne, c), fe(Be, v), fe(Si, n), (d, h) => (f(), y("div", Zi, [
      H($r, {
        class: "product-image",
        blocks: p.value,
        disableVCarousel: o.tcg,
        images: S(u).images,
        "selected-variant": S(n)
      }, null, 8, ["blocks", "disableVCarousel", "images", "selected-variant"]),
      H(Gi, {
        class: "product-details",
        blocks: s.value,
        variables: S(u),
        "selected-variant": S(n)
      }, null, 8, ["blocks", "variables", "selected-variant", 'custom-liquid'])
    ]));
  }
}), ss = /* @__PURE__ */ L(Ki, [["__scopeId", "data-v-5a5b7749"]]);
export {
  ss as default
};
